/* eslint-disable @typescript-eslint/no-explicit-any */
import config from '../config';

export function getBoothSettingsLink(uuid: any) {
  return `${config.boothHost}/#/booth/${uuid}/settings`;
}

export function getDisplaySettingsLink(uuid: any) {
  return `${config.displayHost}/display/${uuid}/settings`;
}

export function getBoothLink(uuid: any) {
  return `${config.boothHost}/#/booth/${uuid}/queues`;
}

export function getDisplayLink(uuid: any, secret: string) {
  return `${config.displayHost}/display/${uuid}?device-key=${secret}`;
}
